var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconGroceryColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#689F38",
    d: "M18.452 13.068s1.554-2.76 1.697-4.319c.045-.488-.13-.97-.541-1.242l-.341-.226A1.243 1.243 0 0118.733 6l.266-.885a1.246 1.246 0 00-.984-1.467l-.955-.083a1.251 1.251 0 01-.97-.92 1.255 1.255 0 00-1.776-.812l-.08.04c-.483.24-1.115.063-1.496-.317l-.054-.053a1.258 1.258 0 00-1.889.133S9.881 2.841 9.31 2.841c-1.23 2.41-.572 10.795-.572 10.795l9.106.817.608-1.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M17.31 18.75v-5.682c0-2.232-1.715-2.012-1.715-6.818h-2.857c0 4.806-1.714 4.586-1.714 6.818v5.682h6.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48FB1",
    d: "M15.595 7.386h-2.857a.571.571 0 01-.571-.568V6.25a.57.57 0 01.571-.568h2.857c.315 0 .572.255.572.568v.568a.571.571 0 01-.572.568z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M16.167 13.068c0-.609-.168-.907-.472-1.45-.272-.485-.596-1.071-.845-1.959h-1.366c-.25.888-.573 1.474-.845 1.96-.305.542-.472.84-.472 1.45v4.545h4v-4.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD54F",
    d: "M5.31 3.977C5.34 1.686 6.325 0 7.596 0c1.27 0 2.286 1.686 2.286 3.977 0 1.58-1.015 2.841-2.286 2.841-1.271 0-2.307-1.262-2.286-2.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD54F",
    d: "M5.31 3.977h4.572v10.227H5.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB300",
    d: "M5.882 7.388s.5-1.243 1.416-2.078c.916-.836 2.012-.763 2.012-.763S8.79 5.756 7.873 6.59c-.916.835-1.991.798-1.991.798zm0 3.977s.5-1.243 1.416-2.079c.916-.834 2.012-.762 2.012-.762s-.521 1.208-1.437 2.043c-.916.835-1.991.798-1.991.798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB40",
    d: "M6.043 15.59l-1.855 8.056A1.138 1.138 0 005.31 25h13.713a1.14 1.14 0 001.132-1.297l-.957-6.658L6.043 15.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB40",
    d: "M18.452 21.657l1.706-8.577a.49.49 0 00-.484-.58H4.66c-.3 0-.53.264-.488.56l1.138 7.395 13.142 1.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "M16.166 17.33l3.148.521-.044-.306.15-.755zm-7.998 1.724l-3.154-.522.14.914-.025.112z"
  }))));
}

export default SvgCommonIconGroceryColor;